import * as React from 'react';
import { BaSeConfig } from '../config/config';

const URL_CONFIG_BY_AUTH_SERVER_URL =
  BaSeConfig.staticAssetsUrl + '/configs/by-auth-server-url.json';

let cache: ConfigByAuthServerUrl;
let timeout: ReturnType<typeof setTimeout>;

const configByAuthServerUrlKeys = [
  'avatarUrl',
  'cpeUrl',
  'jwtAttrAvatar',
  'jwtAttrEmail',
  'jwtAttrName',
  'jwtAttrGivenName',
  'jwtAttrFamilyName',
  'jwtAttrUsername',
  'jwtAttrId',
  'jwtAttrCpf',
] as const;

export type ConfigByAuthServerUrlKey =
  (typeof configByAuthServerUrlKeys)[number];

export interface ConfigByAuthServerUrl {
  [authServerUrl: string]: {
    [key in ConfigByAuthServerUrlKey]: string;
  };
}

export type GetterConfigByAuthServerUrl = ({
  authServerUrl,
  key,
}: {
  authServerUrl?: string;
  key: ConfigByAuthServerUrlKey;
}) => string | undefined;

export function useConfigByAuthServerUrl(): GetterConfigByAuthServerUrl {
  const [config, setConfig] = React.useState<ConfigByAuthServerUrl>();

  React.useEffect(() => {
    if (cache) {
      clearTimeout(timeout);
      return setConfig(cache);
    }

    if (timeout) {
      clearTimeout(timeout);
    }

    timeout = setTimeout(
      () =>
        fetch(URL_CONFIG_BY_AUTH_SERVER_URL)
          .then((response) => response.json())
          .then((remoteConfig: ConfigByAuthServerUrl) => {
            cache = { ...remoteConfig };
            setConfig(remoteConfig);
          }),
      350,
    );
    return () => clearTimeout(timeout);
  }, []);

  const getConfig: GetterConfigByAuthServerUrl = React.useCallback(
    ({ authServerUrl, key }) => {
      if (!authServerUrl) {
        return undefined;
      }
      return config?.[authServerUrl]?.[key];
    },
    [config],
  );

  return getConfig;
}
